<style lang="less">
    @import "../../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list" style="position:relative;height: 100%; min-height: 726px;background: #fff;">
        <div class="table-list" >
            <div class="table-list-title" >
                <span class="myTitle">权利主体管理</span>
                <div class="choose-group">
                    <span class="choose-group-span" >权利主体名称</span>
                    <i-input
                            v-model="userName"
                            ref="workFullnameInput"
                            :search="true"
                            placeholder="请输入权利主体名称"
                            style="width: 205px"
                            class="select-input-style"
                            @on-search="searchData()"
                    ></i-input>
                    <button class="btn-84 addBtn" @click="jumpPage" data-url="/addObligee">添加权利主体</button>
                </div>
            </div>
            <Row class="table-style-size">
                <i-col span="6">权利主体名称</i-col>
                <i-col span="6">权利主体类型</i-col>
                <i-col span="6">证件类型</i-col>
                <i-col span="6">证件号</i-col>
                <i-col span="4">审核状态</i-col>
                <i-col span="4">操作</i-col>
            </Row>

            <errorTips style="padding-top: 75px" :state="0" v-if="loadFlag && records.length == 0"></errorTips>
            <div v-else>
                <Row v-for="(item,index) in records" :key="index" class="table-style-size table-style-body" style="height:65px">
                    <i-col span="6">{{ item.name }}</i-col>
                    <!-- <i-col span="6">
                        <Tooltip style="max-width: 100%;" max-width="200" :content="item.address && item.address!='null' ? item.address : ''"><p  class="partial_result_url">{{ item.address && item.address!='null' ?  item.address : '' }}</p></Tooltip>
                    </i-col> -->
                    <i-col span="6">{{ item.obligeeType == 'person' ? '个人' :'企业' }}</i-col>
                    <i-col span="6" v-if="item.obligeeType == 'person'">居民身份证</i-col>
                    <i-col span="6" v-if="item.obligeeType == 'enterprise'">企业营业执照</i-col>
                    <i-col span="6" v-if="item.obligeeType == 'individual'">其他</i-col>
                    <i-col span="6">{{item.identityNumber}}</i-col>
                    <i-col span="4">
                        <span v-if="item.obligeeRealNameStatus == 'complete_real_name' ">实名成功</span>
                        <span v-else-if="item.obligeeRealNameStatus == 'wait_approve' ">审核中</span>
                        <span v-else-if="item.obligeeRealNameStatus == 'reject_real_name' ">审核失败</span>

                    </i-col>
                    <i-col span="4" class="notwrap">
                        <!-- <span v-if="item.obligeeRealNameStatus == 'complete_real_name' ">实名成功</span>
                        <span v-else-if="item.obligeeRealNameStatus == 'wait_approve' ">审核中</span>
                        <router-link v-else-if="item.obligeeRealNameStatus == 'reject_real_name' && item.isRegister=='1'" style="display: inline-block;" class="btn-84" :to="item.obligeeType == 'enterprise' ? '/enterpriseAuthentication1?id=' + item.registerId : '/personalAuthentication?id=' + item.registerId ">
                            修改后提交
                        </router-link> -->
                       <div class="xiangqinBox">

                            <div class="xiangqin" v-if="item.obligeeRealNameStatus == 'complete_real_name'" @click="gangAnxiangqin(item)">查看详情</div>
                            <div class="xiangqin" v-if="item.obligeeRealNameStatus == 'reject_real_name'" @click="gangAnxiangqinEidt(item)">修改后提交</div>
                            <div  v-if="item.obligeeRealNameStatus == 'complete_real_name' || item.obligeeRealNameStatus == 'reject_real_name'" >
                                <div class="xiangqin" v-if="item.name != userInfoData.name" @click="onDel(index,item.id)">删除</div>
                            </div>
                       </div>
                    </i-col>
                </Row>

                <div style="height:80px"></div>
                <div class="commont-page" style="position: absolute;width: 100%;bottom: 0;height:80px;padding:0;">
                    <Page :page-size="pageSize" :current="pageNumber" @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page>
                    <span class="page-total-span">/&nbsp;{{pages}}页</span>
                </div>
            </div>

        </div>
        <!-- 添加作者 -->
        <dalog ref="dalog"></dalog>
        <!-- 删除 -->
        <logindDalog ref="logindDalog" :dataObj="dataObj" @confirm="confirmDalog"></logindDalog>
    </div>
</template>

<script>
    import {_getByPage,_obligeePowerUserDelete} from "@/api/obligee.js";
    import errorTips from '@/views/main-components/error-tips';
    import logindDalog from '@/viewsGangAn/components/logindDalog';
    import Cookies from "js-cookie";
    import dalog from './dalog.vue'

    export default {
        metaInfo: {
            title: '权利主体管理|前海版权综合服务平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '权利人管理,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: 'walletPay',
        data() {
            return {
                pageNumber: 1,
                pageSize: 9,
                total: 0,
                pages: 1,
                records: [],
                loadFlag:false, //加载flag
                userName: '',
                dataObj: {
                    title:'删除',
                    content:'是否删除？',
                    dalogType: 0
                },
                delId: '',
                userInfoData: Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")): ''
            }
        },
        components: {
            errorTips,
            dalog,
            logindDalog
        },
        mounted() {
            this.getByPage();
        },
        methods: {
            // 删除
            onDel(index,id){
                this.delId = id
                this.delIdIdx = index
                this.$refs.logindDalog.closeDialog()
            },
            confirmDalog(e){
                this._obligeePowerUserDelete()
            },
            _obligeePowerUserDelete(id) {
                let that = this
                _obligeePowerUserDelete(that.delId).then( res => {
                    that.$refs.logindDalog.closeDialog()
                    that.records.splice(this.delIdIdx,1)
                    toast(res.message)
                })
            },
            searchData() {
                this.pageNumber = 1
                this.getByPage()
            },
            getByPage() {
                let userInfo = JSON.parse(Cookies.get("userInfo"));
                const data = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    registerId: userInfo.id,
                    sort: 'createDate',
                    order: 'desc',
                    name: this.userName
                };
                _getByPage(data).then(res => {
                    if (res.code == 200) {
                        var result = res.result;
                        this.total = result.total - 0;
                        this.pages = result.pages;
                        this.records = result.records;
                        this.loadFlag = true;
                    }
                });
            },

            changepage(index) {
                this.pageNumber = index;
                this.getByPage()
            },

            jumpPage(data) {
                // this.$refs.dalog.closeDialog()
                const url = data.target.dataset.url;
                this.$router.push({path: url})
            },
            gangAnxiangqin(item) {
                if (item.obligeeType == 'person' ) {
                    this.$router.push({
                        path: '/gangAnxiangqin?id=' + item.id
                    })
                } else {
                    this.$router.push({
                        path: '/gangAnxiangqin2?id=' + item.id
                    })
                }
            },
            gangAnxiangqinEidt(item) {
                if (item.obligeeType == 'person' ) {
                    this.$router.push({
                        path: '/addPersonalObligee?id=' + item.id
                    })
                } else {
                    this.$router.push({
                        path: '/addEnterpriseObligee?id=' + item.id
                    })
                }
            }
        }
    }
</script>
<style scoped lang="less">
    .partial_result_url {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .center-table-list .table-list {
        flex: 1;
    }
    .xiangqinBox{
        display: flex;
        align-items: center;
    }
    .xiangqin{
        background: #fff !important;
        color: #2196F3 !important;
        border: solid 1px #2196F3 !important;
        width: 70px;
        margin: auto;
        border-radius: 4px;
        cursor: pointer;
        line-height: 24px;
        font-size: 12px;
    }
</style>
